import React from "react";
import { Box, Typography, Button, Paper, Divider } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate } from "react-router-dom";

const ShowFormView = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Box p={2} maxWidth={480}>
      {/* Header Section */}
      <Box sx={{ mb: 1 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
        >
          {data.header || "Form Header"}
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* Body Section */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "medium", color: "text.primary", mb: 1 }}
        >
          Content
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {data.body || "No content available."}
        </Typography>
      </Box>

      {/* Footer Section */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "medium", color: "text.primary", mb: 1 }}
        >
          Footer
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {data.footer || "No footer provided."}
        </Typography>
      </Box>

      {/* Show Form Button */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button
          variant="contained"
          startIcon={<DescriptionIcon />}
          sx={{
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: "medium",
            px: 4,
            py: 1,
            borderRadius: 2,
          }}
          onClick={() => {
            window.open(`/home/${data.formId}/flow-details`, "_blank");
          }}
        >
          {data.buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default ShowFormView;
